"use client"
import { Box, ClickAwayListener, Typography, Avatar, TextField, Button } from "@mui/material";
import React, { useEffect } from "react";
import close from "../../assets/images/close-profile.svg";
import logout from "../../assets/images/logout-icon.svg";
import pattern from "../../assets/images/logout-pattern.png";
import email from "../../assets/images/logoutEmail.svg";
import phoneIcon from "../../assets/images/phone-icon.svg";
import { useState } from "react";
import { styled } from "@mui/system";
import { Image } from "react-bootstrap";
import { clearStorageAndCookies } from "../../services/authService";
import { getMethod, putMethod } from "../../services/apiService";
import { useNavigate } from 'react-router-dom';
import { SHA512 } from 'crypto-js';
import { ToastContext, useToastContext } from '../../context/toastContext';
import IconButton from "@mui/material/IconButton";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import InfoHoverTooltip from "../Tooltips/InfoHover";
import DownloadIcon from '@mui/icons-material/Download';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: "6px",
  right: '9%',
  whiteSpace: 'nowrap',
  width: 1,
  zIndex: 1
});


export const UserProfile = ({ handleUserProfileToggle }: any) => {

  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({ userid: "", name: "", email: "", mobile: "", profilepic: "" });
  const { setPartnerId } = usePartnerIdContext();


  const handleLogout = async () => {
    const resp = await getMethod("central/user/auth/logout");
    if (resp?.data?.code === 200) {
      handleUserProfileToggle();
      clearStorageAndCookies();
      navigate("/login");
      setPartnerId("")
    }
  };



  useEffect(() => {
    var sess_user_ls = localStorage.getItem("sess_user");
    if (sess_user_ls) {
      const sess_user = JSON.parse(sess_user_ls);
      setUserInfo({
        userid: sess_user?.user?.userId,
        name: sess_user?.user?.name + "" + (sess_user?.user?.lastName !== undefined ? (" " + sess_user?.user?.lastName) : ""),
        email: sess_user?.user?.mailId,
        mobile: sess_user?.user?.mobile,
        profilepic: sess_user?.user.profilePicUrl,
      })
    }
  }, []);


  // const [userInfo, setUserInfo] = useState<any>(null);
  const [successfullySentMsg, setSuccessfullySentMsg] = useState("");
  const [showBottomPopup, setShowBottomPopup] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarOpenDashboard, setSnackbarOpenDashboard] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState()
  const [oldPassword, setOldPassword] = useState(""); // State for Old Password
  const [newPassword, setNewPassword] = useState(""); // State for New Password
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false)
  const { setToast } = useToastContext() as ToastContext;


  //For Save Dashboard
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleSnackbarCloseDashboard = () => {
    setSnackbarOpenDashboard(false);
  };
  const handleDashboardSave = () => {
    setSnackbarOpen(true);
    setTimeout(() => {
      setSnackbarOpen(false);
      // setButtonState("preview"); // Change button state to "preview"
    }, 3000);
  };


  const [openModel, setOpenModel] = useState(false);

  const handleClickOpen = () => {
    setOpenModel(true);
  };

  const handleClose = () => {
    setOpenModel(false);
    handleUserProfileToggle(true)
  };


  function getInitials(name: string) {
    const nameParts = name.trim().split(' ').filter(Boolean);
    if (nameParts.length >= 2) {
      const initials = nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
      return initials;
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  }

  const [passwordField, setPasswordField] = useState(false);

  const handleOpenChangePasswordBox = () => {

    setPasswordField(!passwordField)

  };

  const handleClickShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  }

  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword)
  }


  // Hash current password
  const handleChangePassword = async () => {


    let payload = {
      username: userInfo.userid,
      password: SHA512(oldPassword).toString(),
      newpassword: SHA512(newPassword).toString(),
      confirmnewpassword: SHA512(newPassword).toString(),
    };
    console.log(payload, "payload");
    try {

      const resp = await putMethod("central/user/password/update", payload);
      console.log(resp)
      if (resp.status === 200) {
        setToast(resp?.data?.message, "success");
        handleUserProfileToggle();
        clearStorageAndCookies();
        navigate("/login");
      } else {
        setToast(resp?.data?.message, "error");
      }
    } catch (error) {
      setToast("Something Went Wrong", "error");
    }
  };




  const checkForLicense = () => {
    const sess_user = localStorage.getItem("sess_user");
    var sess_user_data = null;
    if (sess_user) {
      sess_user_data = JSON.parse(sess_user);
      if (sess_user_data?.userProfile?.priority && sess_user_data?.userProfile?.priority === 95) {
        return true;
      }
    }
    return false;
  }


  const downloadLicense = async () => {
    const sess_partnerId = localStorage.getItem("partnerId");
    if (sess_partnerId) {
      const resp = await getMethod(`partner/license/key/${sess_partnerId}`);

      if (resp?.status === 200) {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${sess_partnerId}.key`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  return (
    <>
      <ClickAwayListener onClickAway={handleUserProfileToggle}>
        <Box
          sx={{
            backgroundColor: "#192529",
            position: "fixed",
            bottom: '0',
            left: '80px',
            borderRadius: "12px",
            boxShadow: "0px 2px 26px 0px #00000080",
            zIndex: "100",
          }}
        >
          <Image
            src={pattern}
            alt="pattern"
            style={{
              position: "absolute",
              width: "100%",
              zIndex: "1",
              borderRadius: "12px",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              zIndex: "2",
            }}
          >
            <Box
              sx={{
                textAlign: "right",
                width: "100%",
                mb: "40px",
                cursor: "pointer",
              }}
              onClick={handleUserProfileToggle}
            >
              <Image
                src={close}
                alt="close"
                width={20}
                height={20}
                style={{ margin: "18px" }}
              />
            </Box>

            {/* Update Image */}
            <Box sx={{ position: "relative" }} className={'imageContainer'}>

              {/* Upload image */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  height: "100%",
                  width: "100%",
                  display: 'flex',
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
                className={'actionIcon'}
              >
              </Box>

              {/* Profile Image */}
              {userInfo?.profilepic ? <img src={userInfo?.profilepic ?? ""} alt="Profile Photo" className={'profileImg'} style={{ borderRadius: "50%", width: "100px" }} /> : <Avatar sx={{ height: '100px', width: '100px', background: "#0b4a62" }} className={'profileImg'}>{getInitials(userInfo?.name ?? "")}</Avatar>}

            </Box>

            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 500,
                color: "#B4B7B8",
                mb: "12px",
              }}
            >
              {userInfo?.name ?? ""}
            </Typography>

            <Box
              sx={{ display: "flex", gap: "4px", mb: "25px", cursor: "pointer" }}
            >
              <Image src={logout} alt="Logout" />

              <Typography
                sx={{ fontSize: "14px", fontWeight: 500, color: "#E2E3E3" }}
                onClick={handleLogout}
              >
                Sign out
              </Typography>

              {checkForLicense() &&
                <InfoHoverTooltip title="Download license key" arrowDirection="bottom">
                  <DownloadIcon
                    sx={{
                      color: "#17b2eb !important",
                      fontSize: 24,
                      stroke: "#17b2eb",
                      fill: "#17b2eb",
                      marginLeft: "10px",
                      marginTop: "2px",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() => downloadLicense()}
                  />
                </InfoHoverTooltip>
              }
            </Box>

            <Box
              sx={{
                backgroundColor: "#12121299",
                px: "32px",
                py: "24px",
                borderRadius: "8px",
                m: "40px",
                mt: "0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "35px",
                  borderBottom: "1px solid #313838",
                  pb: "24px",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <Image src={email} alt="Email" />

                  <Typography
                    sx={{ fontSize: "16px", fontWeight: 400, color: "#B4B7B8" }}
                  >
                    {userInfo?.email}
                  </Typography>



                </Box>

                <Typography
                  onClick={handleOpenChangePasswordBox} // Add onClick handler here
                  sx={{
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#FFFFFF",
                    textTransform: "uppercase",
                    cursor: "pointer", // Change cursor to pointer to indicate it's clickable
                    pointerEvents: "auto", // Enable pointer events
                  }}
                >
                  CHANGE PASSWORD
                </Typography>

              </Box>

              {passwordField && (
                <Box

                  sx={{
                    marginTop: "16px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >

                  <Box sx={{ position: "relative", width: "100%" }}>
                    <TextField
                      fullWidth
                      label="Old Password"
                      type={showOldPassword ? "text" : "password"}
                      variant="outlined"
                      margin="normal"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#313838",
                          },
                          "&:hover fieldset": {
                            borderColor: "#B4B7B8",
                          },
                        },
                        input: {
                          color: "#E2E3E3",
                        },
                        label: {
                          color: "#B4B7B8",
                        },
                      }}
                    />
                    <IconButton
                      onClick={handleClickShowOldPassword}
                      sx={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        padding: 0,
                      }}
                    >
                      {showOldPassword ? (
                        <img src="/closed-eye.svg" alt="Icon" />
                      ) : (
                        <img src="/open-eye.svg" alt="Icon" />
                      )}
                    </IconButton>
                  </Box>


                  <Box sx={{ position: "relative", width: "100%" }}>
                    <TextField
                      fullWidth
                      label="New Password"
                      type={showNewPassword ? "text" : "password"}
                      variant="outlined"
                      margin="normal"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#313838",
                          },
                          "&:hover fieldset": {
                            borderColor: "#B4B7B8",
                          },
                        },
                        input: {
                          color: "#E2E3E3",
                        },
                        label: {
                          color: "#B4B7B8",
                        },
                      }}
                    />
                    <IconButton
                      onClick={handleClickShowNewPassword}
                      sx={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        padding: 0,
                      }}
                    >
                      {showNewPassword ? (
                        <img src="/closed-eye.svg" alt="Icon" />
                      ) : (
                        <img src="/open-eye.svg" alt="Icon" />
                      )}
                    </IconButton>
                  </Box>


                  <Button
                    variant="contained"
                    onClick={handleChangePassword}
                    sx={{
                      backgroundColor: "#17B2EB",
                      color: "#1F2F34",
                      // marginLeft: 2,
                      textTransform: "none",
                      borderRadius: '30px !important',
                      fontSize: '14px',
                      fontWeight: 'normal',
                      "&:hover": { backgroundColor: "#fff" },
                      // float: 'right',
                    }}
                  >
                    Save
                  </Button>


                </Box>
              )}


              <Box sx={{ display: "flex", alignItems: "center", gap: "4px", paddingTop: "20px" }}>
                <Image src={phoneIcon} alt="phoneIcon" />
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 400, color: "#B4B7B8" }}
                >
                  {userInfo?.mobile}
                </Typography>
              </Box>
            </Box>
          </Box>




        </Box>
      </ClickAwayListener>
    </>


  );
};
